import i18nData from '../i18nData';

const add = (entityName: string, data: unknown) => {
  if (!i18nData[entityName]) {
    i18nData[entityName] = data;
  }
};

const get = (entityName: string) => i18nData[entityName];

const createI18n = (entityName: string) => <T extends unknown>(data: T) => {
  add(entityName, data);
  return get(entityName) as T;
};

export default createI18n;
